import { Component, OnInit, ViewChild, Input, SimpleChanges } from '@angular/core';
import { MatTable, MatDialog, MatDatepickerInputEvent } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { ScheduleDate, Parameter, CompanyRef } from '@akiba/models_bimbo';
import { AppState } from '../../../models/appState';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { take } from 'rxjs/operators';
import { DataSourceService } from '../../../services/data-source.service';
import { LogicService } from '../../../services/logic.service';
import { InfoDialogComponent } from '../../../dialogs/info-dialog/info-dialog.component';

@Component({
  selector: 'app-pending-list-parameters-options',
  templateUrl: './pending-list-parameters-options.component.html',
  styleUrls: ['./pending-list-parameters-options.component.scss']
})
export class PendingListParametersOptionsComponent implements OnInit {
  @Input() contentLocation: AppState;
  @Input() loanListParameters: any;
  @ViewChild('loanListDatesTable', { static: false }) loanListDatesTable: MatTable<ScheduleDate>;
  displayedDatesColumns: string[] = ['InicioCiclo', 'FinCiclo', 'active', 'delete'];
  displayedCompanyColumns: string[] = ['companyID', 'companyName', 'taxationIdentificationNumber', 'select'];
  //selectionCompanies: SelectionModel<CompanyRef>;
 // companies: CompanyRef[];
 // generalSubscription: Subscription = null;
  newLoanListDate = new ScheduleDate;
  loanListDates: Array<ScheduleDate>;
  idLoanListParameter: string = '';
  oldLoanListParameters: any;

  constructor(public dialog: MatDialog, private dataService: DataSourceService, public logicService: LogicService) {
   // this.selectionCompanies = new SelectionModel<CompanyRef>(true, [], true);

    /*this.generalSubscription = this.logicService.dataManager.generalDataLoader.changes.subscribe(p => {
      if (p && p.response) {
        this.companies = this.logicService.dataManager.generalDataLoader.companies;
      }
    });*/

  }


  

  ngOnChanges(changes: SimpleChanges): void {
    this.loanListDates = this.loanListParameters.loanListDates;
    this.idLoanListParameter = this.loanListParameters.idParameter;

  }


  async ngOnInit() {

  }


/*  async setCompany() {
    this.selectionCompanies = new SelectionModel<CompanyRef>(true, [], true);
    if (this.companies === undefined || this.companies.length < 1) {
      this.companies = await this.dataService.loadCompanies().pipe(take(1)).toPromise();
    }
    this.companies.forEach(element => {
      const index = this.loanListParameters.loanListCompanies.map(ic => ic.companyID).indexOf(element.companyID);
      if (index >= 0) {
        this.selectionCompanies.select(element);
      }

    });

  }



  changeCompany(event: any) {
    if (event && event.source) {
      const id: string = event.source.id;
      if (event.checked === true) {
        const index = this.loanListParameters.loanListCompanies.findIndex(ic => ic.companyID === id);
        if (index < 0) {
          this.loanListParameters.loanListCompanies.push({ companyID: id });
        }

      } else {
        const index = this.loanListParameters.loanListCompanies.findIndex(ic => ic.companyID === id);
        this.loanListParameters.loanListCompanies.splice(index, 1);
      }
    }

  }*/

  setRegistrationDate(type: string, event: MatDatepickerInputEvent<moment.Moment>) {
    if (type === 'starts') {
      this.newLoanListDate.startDate = event.value.toDate();
      const nextDay = moment(event.value);

      if (!this.newLoanListDate.endDate) {
        this.newLoanListDate.endDate = nextDay.toDate();
      }

      this.newLoanListDate.weekNumber = event.value.isoWeek();
      const isoWeek = event.value.isoWeek() / 2;
      this.newLoanListDate.biWeekNumber = Math.ceil(isoWeek);

    } else if (type === 'ends') {

      if (!this.newLoanListDate.startDate) {

        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'La necesario especificar la fecha de fin de ciclo.',
            close: 'Aceptar'
          }
        });

        this.newLoanListDate.endDate = null;
        return false;

      }

      const sM = moment(this.newLoanListDate.startDate);
      const eM = event.value;

      if (eM.isSameOrBefore(sM, 'day')) {
        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'La fecha de fin de ciclo no puede ser el mismo dia que la fecha de inicio.',
            close: 'Aceptar'
          }
        });

        this.newLoanListDate.endDate = null;
        return false;

      }

      this.newLoanListDate.endDate = eM.toDate();

    }
  }

  addDate() {
    if (!this.newLoanListDate.startDate || !this.newLoanListDate.endDate) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'La información de fechas esta incompleta.',
          close: 'Aceptar'
        }
      });
      return;
    }

    this.newLoanListDate.active = true;
    this.loanListDates.push(this.newLoanListDate.toAny());
    this.loanListParameters.loanListDates = this.loanListDates;
    this.reset();

    if (this.loanListDatesTable) {
      this.loanListDatesTable.renderRows();
    }
  }

  deleteLoanDate(index: number) {
    this.loanListDates.splice(index, 1);
    this.loanListParameters.loanListDates = this.loanListDates;
    this.loanListDatesTable.renderRows();
  }



  reset() {
    this.newLoanListDate = new ScheduleDate;
    this.newLoanListDate.startDate = null;
    this.newLoanListDate.endDate = null;
    //this.selectionCompanies = new SelectionModel<CompanyRef>(true, [], true);
  }



  /*switchTo(anIndex: number) {
    this.contentLocation.tabIndex = anIndex;
  }*/

  ngOnDestroy(): void {
    this.reset();
    this.contentLocation.tabIndex = 0;
    this.loanListParameters = {
      active: false,
      idParameter: '',
      title: '',
      loanListDates: [],
      loanListCompanies: []
    };

  }

}
